module.exports = __webpack_public_path__ + "static/media/transbank.275b295a.svg";